// frontend/src/components/Login.js
import React, { useState } from 'react';
import {Eye, EyeOff, Mail, Lock} from "lucide-react";
import logo from './../logo.png';

const Login = ({ setToken, onGoToSignUp }) => {
    const [useremail, setUseremail] = useState('');
    const [userpass, setUserpass] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({useremail:"", userpass:""})
    const [loginError, setLoginError] = useState('');

    const validateEmail = (useremail) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(useremail));
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        let hasErrors = false;
        const newErrors = {useremail:"", userpass:""};

        if(!useremail){
            newErrors.useremail = "E-mail necessário";
            hasErrors = true;
        } else if(!validateEmail(useremail)){
            newErrors.useremail = "E-mail inválido";
            hasErrors = true;
        }
        if(!userpass){
            newErrors.userpass = "Senha necessária";
            hasErrors = true;
        }

        setErrors(newErrors);

        if(!hasErrors){
            const response = await fetch('/api/auth/token', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ useremail, userpass })
            });
            const data = await response.json();
            if(response.ok){
                setToken(data.access_token);
            } else {
                setLoginError('E-mail ou senha inválidos');
            }
        }
    };
    
    return (
        <div className="min-vh-100 d-flex align-items-center justify-content-center p-4">
            <div className="w-100" style={{maxWidth: '440px'}}>
                {/* Logo & Header */}
                <img src={logo} className="row mx-auto m-5" alt="Logo" style={{height: '150px'}}/>
                {loginError && (
                    <div className="alert alert-danger" role="alert">
                        {loginError}
                    </div>
                )}
                {/* Login Card */}
                <div className="custom-card p-4 p-md-5">
                    {/* <h2 className="h3 fw-bold mb-2">Login</h2> */}

                    <form onSubmit={handleLogin}>
                        {/* Email Input */}
                        <div className="mb-3">
                            <label htmlFor="email" className="form-label">E-mail</label>
                            <div className="input-group">
                                <span className="input-group-text bg-transparent border-end-0" style={{borderColor:'var(--color-border)', color: 'var(--color-text-secondary)'}}>
                                    <Mail size={18}/> 
                                </span>
                                <input
                                    type="email"
                                    className={`form-control bg-transparent border-start-0 ${errors.useremail ? 'border-danger' : ''}`}
                                    id="email"
                                    placeholder="E-mail"
                                    value={useremail}
                                    onChange={(e) => {
                                        setUseremail(e.target.value);
                                        if(errors.useremail) setErrors({...errors, useremail:""});
                                        if(loginError) setLoginError('');
                                    }}
                                    style={{
                                        borderColor: errors.useremail ? 'var(--color-danger)' : 'var(--color-border)',
                                        color: 'var(--color-text-primary)'
                                    }}
                                />
                            </div>
                            {errors.useremail && (
                                <small className="text-danger-custom d-block mt-1">
                                    {errors.useremail}
                                </small>
                            )}
                        </div>

                        {/* Password Input */}
                        <div className="mb-3">
                            <label htmlFor="password" className="form-label">Senha</label>
                            <div className="input-group">
                                <span className="input-group-text br-transparent border-end-0" style={{borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)'}}>
                                    <Lock size={18}/>
                                </span>
                                <input
                                    type={showPassword ? "text" : "password"}
                                    className={`form-control bg-transparent border-end-0 ${errors.userpass ? 'border-danger' : ''}`}
                                    id="password"
                                    placeholder="Senha"
                                    value={userpass}
                                    onChange={(e) => {
                                        setUserpass(e.target.value);
                                        if(errors.userpass) setErrors({...errors, userpass:""});
                                        if(loginError) setLoginError('');
                                    }}
                                    style={{
                                        borderColor: errors.userpass ? 'var(--color-danger)' : 'var(--color-border)',
                                        color: 'var(--color-text-primary)'
                                    }}
                                />
                                <button
                                    type="button"
                                    className="input-group-text bg-transparent border-start-0"
                                    style={{borderColor: 'var(--color-border)', color: 'var(--color-text-secondary)', cursor:'pointer'}}
                                    onClick={() => setShowPassword(!showPassword)}
                                    aria-label={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                >
                                    {showPassword ? <EyeOff size={18}/> : <Eye size={18}/>}
                                </button>
                            </div>
                            {errors.userpass && (
                                <small className="text-danger-custom d-block mt-1">
                                    {errors.userpass}
                                </small>
                            )}
                        </div>

                        {/* Forgot Password Link */}
                        <div className="text-end mb-4">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-primary-custom text-decoration-none"
                                onClick={() => alert("Funcionalidade em desenvolvimento")}
                            >
                                Esqueceu a senha?
                            </button>
                        </div>

                        {/* Login Button */}
                        <button
                            type="submit"
                            className="btn btn-primary-custom w-100 py-2 mb-3"
                        >
                            Entrar
                        </button>

                        {/* Divider */}
                        {/* <div className="position-relative my-4">
                            <div className="position-absolute w-100 top-50 start-0" style={{borderTop: '1px solid var(--color-border)'}}></div>
                            <div className="text-center position-relative">
                                <span className="px-3 text-muted-custom" style={{backgroundColor: 'var(--color-surface)'}}>
                                    Logue com
                                </span>
                            </div>
                        </div> */}

                        {/* Google Login Button */}
                        {/* <button
                            type="button"
                            onClick={handleGoogleLogin}
                            className="btn btn-outline-custom w-100 py-2 d-flex align-items-center justify-content-center gap-2"
                        >
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M17.64 9.20454C17.64 8.56636 17.5827 7.95272 17.4764 7.36363H9V10.845H13.8436C13.635 11.97 13.0009 12.9231 12.0477 13.5613V15.8195H14.9564C16.6582 14.2527 17.64 11.9454 17.64 9.20454Z" fill="#4285F4"/>
                                <path d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z" fill="#34A853"/>
                                <path d="M3.96409 10.71C3.78409 10.17 3.68182 9.59318 3.68182 9C3.68182 8.40682 3.78409 7.83 3.96409 7.29V4.95818H0.957275C0.347727 6.17318 0 7.54773 0 9C0 10.4523 0.347727 11.8268 0.957275 13.0418L3.96409 10.71Z" fill="#FBBC05"/>
                                <path d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z" fill="#EA4335"/>
                            </svg>
                            Entrar com o Google
                        </button> */}
                    </form>

                    {/* Sign Up Link */}
                    <div className="text-center mt-4 pt-3" style={{borderTop: '1px solid var(--color-border)'}}>
                        <span className="text-muted-custom">Não possui uma conta? </span>
                        <button
                            type="button"
                            className="btn btn-link p-0 text-primary-custom text-decoration-none"
                            onClick={onGoToSignUp}
                        >
                            Cadastrar
                        </button>
                    </div>
                </div>

                {/* Footer */}
                <div className="text-center mt-4">
                    <p className="text-muted-custom small mb-0">&copy; Termos e condições</p>
                </div>
            </div>
        </div>
    );
};

export default Login;